const priceUserIds = new Set([3, 36, 37, 57, 161])

export const canViewPanelPrice = (userId?: number | string | null) =>
  priceUserIds.has(Number(userId))
